export default {
  services:[],
  last_service:{},
  service_single:{},
  pagination:null,
  labs:[],
  lactList:[
    {name:"10 - Lactação Normal"},
    {name:"21 - Lactação Induzida"},
    {name:"14 - Cio"},
    {name:"24 - Nervosismo"},
    {name:"28 - Problema de Casco"},
    {name:"35 - Utilização de BST"},
    {name:"37 - Teto Perdido"},
    {name:"39 - Em Torneio Leiteiro"},
    {name:"12 - Amamentando"},
    {name:"18 - Em exposição"},
    {name:"22 - Mastite"},
    {name:"27 - Outros Prob. Saúde"},
    {name:"33 - Tratada com Ocitocina"},
    {name:"36 - Tratada com Ocitocina e BST"},
    {name:"38 - Proxima inspeção"},
  ],
}